import { Component } from '@angular/core';

/**
 * Divider + sample estimate card (illustrative range only). No zip or API.
 */
@Component({
  selector: 'app-new-roof-cost-calculator',
  standalone: true,
  imports: [],
  templateUrl: './new-roof-cost-calculator.component.html',
  styleUrl: './new-roof-cost-calculator.component.scss',
})
export class NewRoofCostCalculatorComponent {
  /** Illustrative sq ft for internal range math only (not shown in UI). */
  private readonly illustrativeSqFt = 1500;

  readonly costFactors = [
    'Roof size & pitch',
    'Material choice (shingle, metal, tile)',
    'Local contractor rates near you',
  ] as const;

  /** Simple range for display only: base cost to base + 20%. No API. */
  get estimateRange(): string {
    const costPerSqFt = 8;
    const baseCost = this.illustrativeSqFt * costPerSqFt;
    const low = Math.round(baseCost);
    const high = Math.round(baseCost + baseCost * 0.2);
    return `${this.formatUSD(low)} – ${this.formatUSD(high)}`;
  }

  private formatUSD(amount: number): string {
    return `$${amount.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  }
}
